<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import type { FooterFields } from "@citizenm/lobby/shared/types/contentful";

defineProps<{
  navigationGroups: FooterFields["footerNavigation"];
}>();

const breakpoints = useBreakpoints(breakpointsTailwind, { ssrWidth: 1024 });
const mdAndUp = breakpoints.greaterOrEqual("md");
</script>

<template>
  <section class="navigation-groups">
    <nav
      v-for="group in navigationGroups"
      :key="group.fields.title"
      class="navigation-group"
    >
      <LayoutCollapsable
        :name="!mdAndUp ? 'navigation-groups' : ''"
        :is-collapsable="!mdAndUp"
        :is-open="mdAndUp"
      >
        <template #header>
          <span class="navigation-group__header">{{ group.fields.title }}</span>
        </template>
        <template #content>
          <ul
            v-for="item in group.fields.navigationItems"
            :key="item.title"
            class="navigation-group__list"
          >
            <li class="navigation-group__link">
              <LayoutLink :link="item.fields" />
            </li>
          </ul>
        </template>
      </LayoutCollapsable>
    </nav>
  </section>
</template>

<style lang="scss" scoped>
@use "@citizenm/lobby/assets/styles/utils/mixins" as mixins;
/* RESET */
li {
  list-style: none;
}
ul {
  padding: 0;
  margin: 0;
}

/* COMPONENT STYLES */
.navigation-groups {
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  gap: 1rem;

  @include mixins.md {
    flex-direction: row;
    gap: 1.4rem;
  }
}

.navigation-group {
  flex: 1 0 0;

  &__header {
    padding-bottom: var(--space-12, 12px);
  }
  &__list {
    margin-top: 1.5rem;
    @include mixins.md {
      margin-top: 0;
    }
  }

  &__link {
    margin-bottom: 0.5rem;
  }
}
</style>
